import { decryptResponse, encryptResponse } from "../components/encryptResp";

const api_key = process.env.REACT_APP_API_KEY;

// Standardize response handling for all API calls
const handleApiResponse = async (response) => {
    try {
        const data = await response.json();
        return decryptResponse(data.encrypted, data.iv);
    } catch (error) {
        console.error('API Response Error:', error);
        return { status: false, message: "Internet Server Error" };
    }
};

const AdminAuthCheck = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch('/api/admin/Authorization', {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Auth Check" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const AdminLogin = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch('/api/admin/login', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const LoginOtp = async (body) => {
    const token = localStorage.getItem('token');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/login/otp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const GetAdminData = async () => {
    const token = localStorage.getItem('picpromptify_admin');

    try {
        const resp = await fetch(`/api/admin/AdminData`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const AdminProfileUpdate = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/Profile/Update`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const ForgetPw = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/ForgetPw`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const ForgetPwOtp = async (body) => {
    const token = localStorage.getItem('forgetPw');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/ForgetPwOtp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Barear ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const ResetPassword = async (body) => {
    const token = localStorage.getItem('forgetPw');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/NewPassword`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Barear ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// Ui Intro Screen

const getIntroScreen = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ui/introscreen?a=true`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIntroScreen = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ui/introscreen/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIntroScreenStatus = async (id) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ui/introscreen/update/status/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteIntroScreen = async (id) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ui/introscreen/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIntroScreen = async (id, formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ui/introscreen/update/${id}`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }

}

// Controller
const getControlleData = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/controller/admin/`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateControllerPosition = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/controller/admin/position/update`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Facebook
const setControleFacebook = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/controller/admin/fb/update`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Controller Story Ads
const updateControllerStory = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/controller/admin/story/update`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Native Ads
const getNativeAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/native/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateNativeAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/native/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addNativeAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/native/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteNativeAds = async (id) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/native/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Full Screen Ads
const getFullScreenAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateFullScreenAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addFullScreenAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteFullScreenAds = async (id) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Banner Ads
const getBannerAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/banner/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateBannerAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/banner/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addBannerAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/banner/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Open Ads
const getOpenAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/open/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addOpenAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/open/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateOpenAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/open/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Reward Ads
const getRewardAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addRewardAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/reward/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateRewardAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/reward/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteRewardAds = async (id) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// In House Ads
const uploadInHouseAds = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/inhouse`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getInHouseAds = async (page, limit, q) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/inhouse?a=true&page=${page}&limit=${limit}&q=${q}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setInHouseAdsStatus = async (id, status) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const body = {
            id,
            status
        }
        const resp = await fetch(`/api/app/ads/inhouse/update/status`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': api_key
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteInhouseAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/inhouse`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const getInHouseAdsData = async (id) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/inhouse/data/${id}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateInHouseAds = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/ads/inhouse`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Admin Views Dashbord and Click Dashbord
const adminViewsDashbord = async (id, startDate, endDate) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {

        const resp = await fetch(`/api/admin/view/dashbord/${id}?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// AI Model
const getAiModel = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/aiModel/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addAiModel = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/aiModel/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateAiModel = async (id, formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/aiModel/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteAiModel = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/aiModel/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// List
const getList = async (page, limit, q, category, view, pro) => {
    const token = localStorage.getItem('picpromptify_admin');

    try {
        // Build query params safely
        const params = new URLSearchParams({
            page: String(page),
            limit: String(limit)
        });

        if (q) params.append("q", q);
        if (category) params.append("category", category);
        if (view) params.append("view", view);
        if (pro) params.append("pro", view);

        const resp = await fetch(`/api/app/list/admin?${params.toString()}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });

        return handleApiResponse(resp);
    } catch (error) {
        console.error("getList error:", error);
        return { status: false, message: "Internal Server Error" };
    }
};

const addList = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/list/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateList = async (id, formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/list/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteList = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/list/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Category
const getCategory = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/category/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addCategory = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/category/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateCategory = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/category/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteCategory = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/category/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Wallpaper Category
const getWallpaperCategory = async (params = {}) => {
    const token = localStorage.getItem('picpromptify_admin');
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );
    const query = new URLSearchParams(clean).toString();
    try {
        const resp = await fetch(`/api/app/wallpaper/category/admin${query ? `?${query}` : ''}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addWallpaperCategory = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/wallpaper/category/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateWallpaperCategory = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/wallpaper/category/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteWallpaperCategory = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/wallpaper/category/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Inpix Category
const getInpixCategory = async (params = {}) => {
    const token = localStorage.getItem('picpromptify_admin');
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );
    const query = new URLSearchParams(clean).toString();
    try {
        const resp = await fetch(`/api/app/inpix/category/admin${query ? `?${query}` : ''}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addInpixCategory = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/inpix/category/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateInpixCategory = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/inpix/category/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteInpixCategory = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/inpix/category/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Wallpaper
const getWallpaper = async (params = {}) => {
    const token = localStorage.getItem('picpromptify_admin');
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );
    const query = new URLSearchParams(clean).toString();
    try {
        const resp = await fetch(`/api/app/wallpaper/admin${query ? `?${query}` : ''}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addWallpaper = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/wallpaper/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateWallpaper = async (id, formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/wallpaper/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteWallpaper = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/wallpaper/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Inpix Template (admin)
const getInpixTemplate = async (params = {}) => {
    const token = localStorage.getItem('picpromptify_admin');
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );
    const query = new URLSearchParams(clean).toString();
    try {
        const resp = await fetch(`/api/app/inpix/template/admin${query ? `?${query}` : ''}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addInpixTemplate = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/inpix/template/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateInpixTemplate = async (id, formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/inpix/template/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteInpixTemplate = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/inpix/template/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Inpix Frame (admin)
const getInpixFrame = async (params = {}) => {
    const token = localStorage.getItem('picpromptify_admin');
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );
    const query = new URLSearchParams(clean).toString();
    try {
        const resp = await fetch(`/api/app/inpix/frame/admin${query ? `?${query}` : ''}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addInpixFrame = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/inpix/frame/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateInpixFrame = async (id, formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/inpix/frame/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteInpixFrame = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/inpix/frame/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Policy
const getPolicy = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/policy/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updatePolicy = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/policy/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Gaid
const getGuide = async () => {
    const token = localStorage.getItem('picpromptify_admin');

    try {
        const endpoint = `/api/app/guide/video/admin`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Gaid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const updateGuide = async (id, formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const endpoint = `/api/app/guide/video/admin/${id}`;
        const resp = await fetch(endpoint, {
            method: 'PUT',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Server Load Checker
const GetServerLoadCheck = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/server/load/check`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Ios
const getIosNativeAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/ios/ads/native/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosNativeAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/native/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosNativeAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/native/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Full Screen Ads
const getIosFullScreenAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/ios/ads/fullScreen/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosFullScreenAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/fullScreen/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosFullScreenAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/fullScreen/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Banner Ads
const getIosBannerAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/ios/ads/banner/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosBannerAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/banner/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosBannerAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/banner/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Open Ads
const getIosOpenAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/ios/ads/open/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosOpenAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/open/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosOpenAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/open/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Reward Ads
const getIosRewardAds = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/ios/ads/reward/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosRewardAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/reward/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosRewardAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/reward/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Web Site
const getIosWebAds = async (startDate, endDate) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/ios/ads/webads/admin/get?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosWebAds = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/webads/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosWebAds = async (id, body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/webads/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteIosWeb = async (id) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/ios/ads/webads/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteIosWebClear = async (id, startDate, endDate) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/ios/ads/webads/count/remove/${id}?startDate=${startDate}&endDate=${endDate}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const allIosdeleteWebClear = async (body, startDate, endDate) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/webads/count/all/remove?startDate=${startDate}&endDate=${endDate}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Banner
const getBanner = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/banner/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addBanner = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');

    try {
        const resp = await fetch(`/api/app/banner/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateBanner = async (id, formData) => {
    const token = localStorage.getItem('picpromptify_admin');

    try {
        const resp = await fetch(`/api/app/banner/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteBanner = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/banner/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Notification
const getNotification = async (page, limit) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/notification/admin/history?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const sendNotification = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/notification/admin/send`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const resendNotification = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/admin/resend`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteNotification = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/admin/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const productNotification = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/admin/product`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Dashboard
const getDashboard = async (startDate, endDate, type) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/admin/dashboard?startDate=${startDate}&endDate=${endDate}&type=${type}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Story
const getStory = async (page, limit) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/story/admin?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addStory = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/story/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteStory = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/story/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Suggestion

const getSuggestion = async (page, limit) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/suggestion/admin?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteSuggestion = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/suggestion/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// AdsTxt
const getAdsTxt = async () => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/admin/ads/txt`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateAdsTxt = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/ads/txt`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Blog
const getBlog = async (page, limit, search, status) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/blog/admin?page=${page}&limit=${limit}&search=${search}&status=${status}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getBlogId = async (id) => {
    const token = localStorage.getItem('picpromptify_admin');
    try {
        const resp = await fetch(`/api/app/blog/admin/${id}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addBlog = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');

    try {
        const resp = await fetch(`/api/app/blog/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateBlog = async (formData) => {
    const token = localStorage.getItem('picpromptify_admin');

    try {
        const resp = await fetch(`/api/app/blog/admin`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteBlog = async (body) => {
    const token = localStorage.getItem('picpromptify_admin');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/blog/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const Calling = {
    AdminLogin, AdminAuthCheck, ResetPassword, LoginOtp, GetAdminData, AdminProfileUpdate, ForgetPw, ForgetPwOtp,
    getIntroScreen, addIntroScreen, updateIntroScreenStatus, deleteIntroScreen, updateIntroScreen,
    getControlleData, updateControllerPosition, setControleFacebook, updateControllerStory,
    getNativeAds, updateNativeAds, addNativeAds, deleteNativeAds,
    getFullScreenAds, updateFullScreenAds, addFullScreenAds, deleteFullScreenAds,
    getBannerAds, updateBannerAds, addBannerAds,
    getOpenAds, updateOpenAds, addOpenAds,
    getRewardAds, updateRewardAds, addRewardAds, deleteRewardAds,
    uploadInHouseAds, getInHouseAds, setInHouseAdsStatus, deleteInhouseAds, getInHouseAdsData, updateInHouseAds,
    adminViewsDashbord,
    getAiModel, addAiModel, updateAiModel, deleteAiModel,
    getList, addList, updateList, deleteList,
    getCategory, addCategory, updateCategory, deleteCategory,
    getWallpaperCategory, addWallpaperCategory, updateWallpaperCategory, deleteWallpaperCategory,
    getInpixCategory, addInpixCategory, updateInpixCategory, deleteInpixCategory,
    getInpixTemplate, addInpixTemplate, updateInpixTemplate, deleteInpixTemplate,
    getInpixFrame, addInpixFrame, updateInpixFrame, deleteInpixFrame,
    getWallpaper, addWallpaper, updateWallpaper, deleteWallpaper,
    getPolicy, updatePolicy,
    getGuide, updateGuide,
    GetServerLoadCheck,
    getIosNativeAds, updateIosNativeAds, addIosNativeAds,
    getIosFullScreenAds, updateIosFullScreenAds, addIosFullScreenAds,
    getIosBannerAds, updateIosBannerAds, addIosBannerAds,
    getIosOpenAds, updateIosOpenAds, addIosOpenAds,
    getIosRewardAds, updateIosRewardAds, addIosRewardAds,
    getIosWebAds, addIosWebAds, updateIosWebAds, deleteIosWeb, deleteIosWebClear, allIosdeleteWebClear,
    getBanner, addBanner, updateBanner, deleteBanner,
    getNotification, sendNotification, resendNotification, deleteNotification, productNotification,
    getDashboard,
    getStory, addStory, deleteStory,
    getSuggestion, deleteSuggestion,
    getAdsTxt, updateAdsTxt,
    getBlog, updateBlog, getBlogId, deleteBlog, addBlog
}

export default Calling;